export default __webpack_public_path__ + "static/media/kulczyk.659a7232.svg";